import { Component, forwardRef, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import _ from "lodash";
import { ArbetsorderSearchBase } from "../../../models/arbetsorder-search-base";
import { TradslagsFilter } from "./../../../../model/TradslagsFilter";

@Component({
    selector: "rask-arbetsorder-search-skoglig-data-tradslag",
    templateUrl: "./arbetsorder-search-skoglig-data-tradslag.component.html",
    styleUrls: ["./arbetsorder-search-skoglig-data-tradslag.component.scss"],
    providers: [
        { provide: ArbetsorderSearchBase,
            useExisting: forwardRef(() => ArbetsorderSearchSkogligDataTradslagComponent) }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputNumberComponent,
        FormsModule
    ]
})
export class ArbetsorderSearchSkogligDataTradslagComponent extends ArbetsorderSearchBase implements OnInit {

    constructor() {
        super();
    }
    ngOnInit(): void {
        this.applyFilter();
    }

    forceUpdateFilterChange(): void {
        this.applyFilter();
    }

    private applyFilter() {
        if (_.isNil(this.searchFilter.skogligdata.tradslag)) {
            this.searchFilter.skogligdata.tradslag = new TradslagsFilter();
        }
    }
}
